import { Music, ExternalLink } from 'lucide-react';

const CornExchangeWhatsOnSection = () => {
  return (
    <div className="content-card" data-testid="cornexchange-whatson-section">
      <div className="card-header">
        <h2>
          <Music size={20} className="inline" /> King's Lynn Corn Exchange
        </h2>
      </div>
      <div className="card-content whatson-content">
        <div className="whatson-container">
          <p className="whatson-description">
            Theatre, comedy, music and entertainment venue in the heart of King's Lynn.
          </p>
          <a 
            href="https://www.kingslynncornexchange.co.uk/theatre/whats-on/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="whatson-link-btn"
          >
            <Music size={18} />
            View What's On at Corn Exchange
            <ExternalLink size={16} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default CornExchangeWhatsOnSection;
